import { AccessMedia } from '@app/core/models/models';
import { Pipe, PipeTransform } from '@angular/core';
import { JourneyPortal } from '@app/core/models/journey/journey-portal';

@Pipe({
  name: 'findAccessMedia',
  pure: true
})
export class FindAccessMediaPipe implements PipeTransform {
  transform(accessMedias: AccessMedia[], journey: JourneyPortal): AccessMedia {
    if (journey && journey.taps && journey.taps.length > 0 && accessMedias && accessMedias.length > 0) {
      const identificationToken = journey.taps[0].identificationToken;
      return accessMedias.find(({ tokens }) => tokens.filter(token => token.accessMediaToken === identificationToken ).length > 0);
    }
  }
}
